import { useCallback } from 'react';
import type { FieldErrorSource } from '@ai-content-hub/ui/field';

import { useFieldErrorsStore } from '@/store/fieldErrorsStore';

/**
 * EAA-1666: concrete `FieldErrorSource` — the seam that lets `packages/ui`'s
 * field kit (`FieldInput`, `FieldSelect`, `FieldTextArea`) read/clear scoped
 * field errors without depending on this app's store directly.
 *
 * EAA-1670: backing store swapped from the Redux `fieldErrors` slice to a
 * Zustand store (see docs/plans/fe-restructure/phase-7-state-migration.md) —
 * the seam's public shape is unchanged, so `packages/ui` needed zero edits.
 * Each method stays a one-field subscription (not the whole `byScope[scope]`
 * object) to match the existing perf guidance for this slice.
 */
export const webContentFieldErrorSource: FieldErrorSource = {
    useFieldMessage(scope, field) {
        return useFieldErrorsStore((state) => state.byScope[scope]?.[field]);
    },
    useClearField(scope, field) {
        const clearFieldError = useFieldErrorsStore((state) => state.clearFieldError);
        return useCallback(() => {
            clearFieldError(scope, field);
        }, [clearFieldError, scope, field]);
    },
};
